import React from 'react';
import css from './CategoriesMenu.module.css';

const CategoriesMenu = () => {
  const [showMenu, setShowMenu] = React.useState(false);

  const buttons = [
    { label: 'All', value: '/s' },
    { label: 'New', value: '/s?sort=createdAt' },
    { label: 'Locations', value: '/s?pub_categoryLevel1=locations' },
    { label: 'Items', value: '/s?pub_categoryLevel1=items' },
  ];
  return (
    <div className={css.wrapper}>
      <div className={css.buttonWrapper} onClick={() => setShowMenu((prev) => !prev)}>
        <div className={css.dropdownButton}>Top Categories</div>
        <b className={`${css.searchIcon} ${showMenu ? css.iconFadeOut : css.iconSpinIn}`}></b>
        <b className={`${css.hamburgerIcon} ${showMenu ? css.iconSpinIn : css.iconFadeOut}`}></b>
      </div>
      {showMenu && (
        <div className={css.menu}>
          {buttons.map((button) => (
            <a key={button.value} href={button.value} className={css.menuItem}>
              {button.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoriesMenu;
